
    module.exports = {
      bytes: 177605,
      height: 158,
      orientation: undefined,
      src: __webpack_public_path__ + "c099b82c45e27f1a510de7485cb77570.svg",
      type: "svg",
      width: 216,
    };
    /**
     * For requires from CSS when used with webpack css-loader,
     * outputting an Object doesn't make sense,
     * so overriding the toString method to output just the URL.
     */
    module.exports.toString = function() {
      return __webpack_public_path__ + "c099b82c45e27f1a510de7485cb77570.svg";
    };
  